import React from "react"
import styled from "styled-components"
import { StaticImage } from "gatsby-plugin-image"

const LogoWrapper = styled.div`
  @media (max-width: 768px) {
    margin-left: 20px;
    order: 2;
  }
`

export const Logo = () => {
  return (
    <LogoWrapper className="logo">
      <StaticImage
        src="../../../../images/logo.png"
        alt="Barragans Restaurant"
        height={40}
        placeholder="blurred"
      />
    </LogoWrapper>
  )
}
